import { render, staticRenderFns } from "./candidateTableEditTwo.vue?vue&type=template&id=52db81ae"
import script from "./candidateTableEditTwo.vue?vue&type=script&lang=js"
export * from "./candidateTableEditTwo.vue?vue&type=script&lang=js"
import style0 from "./candidateTableEditTwo.vue?vue&type=style&index=0&id=52db81ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports